import { useState } from 'react';
import { HotelMap } from '../components/hotels/hotel-map';

// Test data with coordinates
const testHotels = [
  {
    id: 'hotel-1',
    name: 'Hotel Test 1',
    location: 'Miami Beach',
    coordinates: {
      latitude: 25.7617,
      longitude: -80.1918,
      address: '123 Ocean Drive, Miami Beach, FL'
    },
    price: { amount: 250, currency: 'USD' },
    starRating: 4,
    amenities: ['WiFi', 'Pool', 'Spa']
  },
  {
    id: 'hotel-2',
    name: 'Hotel Test 2',
    location: 'Downtown Miami',
    coordinates: {
      latitude: 25.7700,
      longitude: -80.2000,
      address: '456 Biscayne Blvd, Miami, FL'
    },
    price: { amount: 180, currency: 'USD' },
    starRating: 3,
    amenities: ['WiFi', 'Gym']
  },
  {
    id: 'hotel-3',
    name: 'Hotel Test 3',
    location: 'South Beach',
    coordinates: {
      latitude: 25.7800,
      longitude: -80.2100,
      address: '789 Collins Ave, Miami Beach, FL'
    },
    price: { amount: 320, currency: 'USD' },
    starRating: 5,
    amenities: ['WiFi', 'Pool', 'Spa', 'Gym', 'Restaurant']
  }
];

export default function TestMapButtonPage() {
  const [selectedHotelId, setSelectedHotelId] = useState<string | null>(null);
  const [clickedHotelId, setClickedHotelId] = useState<string | null>(null);

  const handleMarkerClick = (hotelId: string) => {
    console.log('Marker clicked:', hotelId);
    setClickedHotelId(hotelId);
    
    // Scroll to hotel in list
    const hotelElement = document.getElementById(`hotel-${hotelId}`);
    if (hotelElement) {
      hotelElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      
      // Add temporary highlight
      hotelElement.classList.add('ring-2', 'ring-blue-500', 'ring-opacity-50');
      setTimeout(() => {
        hotelElement.classList.remove('ring-2', 'ring-blue-500', 'ring-opacity-50');
      }, 2000);
    }
  };

  const handleHotelHover = (hotelId: string | null) => {
    setSelectedHotelId(hotelId);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">
          Test Map Button - Hotel Map View
        </h1>
        
        {/* Status Display */}
        <div className="mb-6 p-4 bg-white rounded-lg border">
          <h3 className="text-lg font-semibold mb-2">Status</h3>
          <p>Selected Hotel: {selectedHotelId || 'None'}</p>
          <p>Clicked Hotel: {clickedHotelId || 'None'}</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Hotel List */}
          <div className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Hotels ({testHotels.length})
            </h2>
            <div className="space-y-3 max-h-[600px] overflow-y-auto">
              {testHotels.map((hotel) => (
                <div
                  key={hotel.id}
                  id={`hotel-${hotel.id}`}
                  className={`p-4 bg-white rounded-lg border cursor-pointer transition-all duration-200 ${
                    selectedHotelId === hotel.id 
                      ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-500 ring-opacity-50' 
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                  onMouseEnter={() => handleHotelHover(hotel.id)}
                  onMouseLeave={() => handleHotelHover(null)}
                >
                  <h3 className="font-semibold text-gray-900">{hotel.name}</h3>
                  <p className="text-green-600 font-medium">
                    ${Math.round(hotel.price.amount)} / night
                  </p>
                  <p className="text-sm text-gray-600">{hotel.coordinates.address}</p>
                  <p className="text-xs text-gray-500">
                    📍 {hotel.coordinates.latitude.toFixed(4)}, {hotel.coordinates.longitude.toFixed(4)}
                  </p>
                  <div className="mt-2 flex flex-wrap gap-1">
                    {hotel.amenities.slice(0, 3).map((amenity, index) => (
                      <span key={index} className="px-2 py-1 bg-gray-100 text-xs rounded">
                        {amenity}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Map */}
          <div>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Map
            </h2>
            <div className="h-[600px] w-full">
              <HotelMap
                hotels={testHotels}
                onMarkerClick={handleMarkerClick}
                hoveredHotelId={selectedHotelId}
                onMarkerHover={handleHotelHover}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
